var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card-group",
    { staticClass: "card-group-landing" },
    [
      _c(
        "b-card",
        { attrs: { "no-body": "" } },
        [
          _c("news-content-card", {
            attrs: {
              "news-card-title": _vm.newsCardProps.title,
              "news-card-bundle": _vm.newsCardProps.bundle
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-card",
        { attrs: { "no-body": "" } },
        [
          _c("links-content-card", {
            attrs: {
              "link-card-title": _vm.linkCardProps.startHere.title,
              "link-card-bundle": _vm.linkCardProps.startHere.bundle
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-card",
        { attrs: { "no-body": "" } },
        [
          _c("links-content-card", {
            attrs: {
              "link-card-title": _vm.linkCardProps.quickLinks.title,
              "link-card-bundle": _vm.linkCardProps.quickLinks.bundle
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9cd53988", { render: render, staticRenderFns: staticRenderFns })
  }
}